export default __webpack_public_path__ + "static/media/gallery_07.ab66f11d.jpg";